import { ChangeEventHandler } from 'react';

// Types
export interface Props {
  id?: string;
  heading?: string;
  helper?: string;
  onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
  onRemove?: () => void;
  multiple?: boolean;
  accept?: string[];
  progress?: number;
  fileSize?: number;
  fileName?: string;
  success?: boolean;
  error?: boolean;
  invalid?: boolean;
}

// Variables
export const defaultHeading = 'Haz clic para cargar archivo';
export const defaultId = 'file-upload';
export const defaultAccept = ['svg', 'png', 'jpg', 'gif'];
